"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
class RequestError extends Error {
  toString() {
    return this.message;
  }
}
exports.default = RequestError;
module.exports = exports["default"];
//# sourceMappingURL=RequestError.js.map



// WEBPACK FOOTER //
// ./src/request-promise-lite/lib/RequestError.js